function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 100 60"
}, props), React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  fill: "#26337A",
  width: "100",
  height: "60",
  rx: "4"
}), React.createElement("path", {
  fill: "#FFFFFE",
  d: "M41.49 39.547l3.075-19.074h4.915l-3.075 19.074H41.49M64.233 20.94c-.972-.382-2.5-.8-4.404-.8-4.86 0-8.28 2.589-8.308 6.295-.031 2.742 2.44 4.271 4.304 5.182 1.915.935 2.559 1.532 2.551 2.368-.013 1.277-1.529 1.862-2.942 1.862-1.967 0-3.013-.288-4.63-1l-.631-.304-.688 4.27c1.146.531 3.27.992 5.476 1.017 5.164 0 8.52-2.558 8.559-6.516.018-2.174-1.292-3.822-4.128-5.182-1.718-.885-2.772-1.47-2.76-2.366.001-.792.89-1.641 2.816-1.641a8.62 8.62 0 013.678.733l.441.218.666-4.135m6.544 11.843c.408-1.096 1.958-5.331 1.958-5.331-.028.05.405-1.105.653-1.82l.332 1.645s.943 4.553 1.138 5.506h-4.08zm6.064-12.292h-3.799c-1.178 0-2.06.338-2.576 1.581l-7.299 17.48h5.163s.842-2.351 1.033-2.867c.563 0 5.58.01 6.295.01.147.665.599 2.858.599 2.858h4.561l-3.977-19.062zm-39.474-.003l-4.81 13.004-.516-2.644c-.897-3.045-3.687-6.346-6.808-8l4.4 16.681 5.202-.003 7.74-19.038h-5.208"
}), React.createElement("path", {
  d: "M28.09 20.476h-7.925l-.065.395c6.167 1.58 10.247 5.394 11.94 9.978l-1.721-8.764c-.298-1.209-1.161-1.567-2.228-1.61",
  fill: "#EC982D"
}))));